import client from "./client";

export async function searchDiamonds(body, { signal } = {}) {
    const res = await client.post("natural-diamonds", body, { signal });
    return res?.data?.data?.data ?? [];
}

export async function countDiamonds(body, { signal } = {}) {
    const res = await client.post("diamond-count", body, { signal });
    return res?.data?.data?.diamondcount ?? "00";
}

export async function createDiamondProduct(body, { signal } = {}) {
    const res = await client.post("create-diamond-product", body, { signal });
    return res?.data?.data ?? null;
}
